import React from 'react';
type LogoProps = {
  /** 'ink' for light backgrounds, 'paper' for dark backgrounds. */
  tone?: 'ink' | 'paper';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
const sizes = {
  sm: 'text-[23px]',
  md: 'text-[28px]',
  lg: 'text-[33px]'
};

/**
 * NexLegal identity: a pure wordmark — tight-tracked display type, single
 * colour, no mark. Restraint is the brand cue.
 */
export function Logo({
  tone = 'ink',
  size = 'sm',
  className = ''
}: LogoProps) {
  const wordmark = tone === 'ink' ? 'text-ink' : 'text-paper';
  return <span className={`inline-block font-display ${sizes[size]} font-medium leading-none tracking-tightest ${wordmark} ${className}`} data-id="element-64" data-mp="rrfgfd48r4p2">
      NexLegal
    </span>;
}